import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footcard',
  templateUrl: './footcard.component.html',
  styleUrls: ['./footcard.component.scss'],
})
export class FootcardComponent implements OnInit 
{
  text:string;

  constructor() 
  { 
    console.log("FootcardComponent.ctor - LifeCycle:");
    this.text = "Hello FootcardComponent";
  }

  ngOnInit() 
  {
    console.log("FootcardComponent.ngOnInit - LifeCycle");
  }
}
